import React from "react";
import { getDefaultWorkspaceCardContext } from "./default.workspace.card.context";

export type WorkspaceCardContextPayload = {
  isFavorite: boolean;
};

export const WorkspaceCardContext =
  React.createContext<WorkspaceCardContextPayload>(
    getDefaultWorkspaceCardContext(),
  );
